import { CloneRequestPageCommandV1, CreateRequestPageCommandV1, DeleteRequestPageCommandV1 } from '@Pages/Domain/commands-core';
import PagesCommands from '@Pages/Domain/commands-vue-component';
import PagesQueries from '@Pages/Domain/queries-vue-component';
import { RequestPageReadModel, RequestPagesPageReadModel } from '@Pages/Domain/readmodels';
import { ICommandBase } from '@Pages/cqrs';
import { dateCompare1, generateName, strCompareLowerCase } from '@common/Common';
import PortfolioOrDecisionNavigation from "@common/Components/PortfolioOrDecisionNavigation.vue";
import { dynamicUiRoutes } from '@common/dynamicUiRoutes';
import moment from "moment";
import { Component, mixins } from 'vue-facing-decorator';


@Component({ components: { PortfolioOrDecisionNavigation } })
export default class RequestPagesPage extends mixins(PagesQueries, PagesCommands)
{
    get workspaceId(): number { return Number(this.$route?.params?.workspaceId ?? 0); }
    get projectId(): number { return Number(this.$route?.params?.projectId ?? 0); }

    url_EditRequestPagePage(pageId: number): string
    {
        return dynamicUiRoutes.Pages_EditRequestPagePage(this.$route, this.workspaceId, this.projectId, pageId);
    }


    rm: RequestPagesPageReadModel = null;
    SearchPhrase: string = null;
    OrderBy: string = "modified";
    OrderByDescending: boolean = true;

    page: RequestPageReadModel = null;

    get pagesView()
    {
        let view = new Array(...this.rm.Pages);

        if (this.SearchPhrase)
        {
            const phrase = this.SearchPhrase.toLowerCase();
            view = view.filter(o => o.Name.toLowerCase().indexOf(phrase) >= 0);
        }

        if (this.OrderBy === "name")
        {
            view = view.sort((a, b) => strCompareLowerCase(a.Name, b.Name));
        }
        else if (this.OrderBy === "modified")
        {
            view = view.sort((a, b) => dateCompare1(a.Modified, b.Modified));
        }
        else if (this.OrderBy === "created")
        {
            view = view.sort((a, b) => dateCompare1(a.Created, b.Created));
        }

        if (this.OrderByDescending === true)
        {
            view = view.reverse();
        }

        return view;
    }



    getFormattedDateStr(date: string): string | null
    {
        if (date)
        {
            return moment(date).format('MMM D, YYYY');
        }

        return null;
    }

    getFormattedTimeStr(date: string): string | null
    {
        if (date)
        {
            return moment(date).format('LT');
        }

        return null;
    }

    orderByName()
    {
        if (this.OrderBy === 'name')
        {
            this.OrderByDescending = !this.OrderByDescending;
        }
        else
        {
            this.OrderByDescending = false;
            this.OrderBy = 'name';
        }
    }

    orderByModified()
    {
        if (this.OrderBy === 'modified')
        {
            this.OrderByDescending = !this.OrderByDescending;
        }
        else
        {
            this.OrderByDescending = true;
            this.OrderBy = 'modified';
        }
    }

    orderByCreated()
    {
        if (this.OrderBy === 'created')
        {
            this.OrderByDescending = !this.OrderByDescending;
        }
        else
        {
            this.OrderByDescending = true;
            this.OrderBy = 'created';
        }
    }

    CopyUrlCommand()
    {
        navigator.clipboard.writeText(this.page.Url).then(() => 
        {
            const url = this.page.Url;
            this.page.Url = "Copied to clipboard";

            const handle = setTimeout(() =>
            {
                this.page.Url = url;
                clearTimeout(handle);
            }, 700);
        }).catch(err => { console.error('Failed to copy: ', err); });
    }

    handleCloneRequestPageCommand(p: RequestPageReadModel)
    {
        this.invokeCloneRequestPageCommandV1(this.workspaceId, this.projectId, p.Id, generateName(p.Name));
    }

    handleDeleteRequestPageCommand(p: RequestPageReadModel)
    {
        if (confirm("Are you sure?") == true)
        {
            this.invokeDeleteRequestPageCommandV1(this.workspaceId, this.projectId, p.Id);
        }
    }

    handleCreateRequestPageCommand()
    {
        this.invokeCreateRequestPageCommandV1(this.workspaceId, this.projectId, 0, generateName("Request page"));
    }


    mounted()
    {
        document.title = "Request pages | TransparentChoice";
        this.runRequestPagesPageQueryV1(this.workspaceId, this.projectId);
    }


    onSetModel(model: any, modelName: string) 
    {
        if (modelName == "RequestPagesPageReadModel")
        {
            this.rm = model as RequestPagesPageReadModel;
        }
    }

    onCommandSucceed(cmd: ICommandBase, correlationId: string, result: any)
    {
        if (CreateRequestPageCommandV1.matchType(cmd))
        {
            const pageId = Number(result);
            window.location.href = this.url_EditRequestPagePage(pageId);
        }
        else if (CloneRequestPageCommandV1.matchType(cmd))
        {
            const pageId = Number(result);
            window.location.href = this.url_EditRequestPagePage(pageId);
        }
        else if (DeleteRequestPageCommandV1.matchType(cmd))
        {
            const pageId = Number(correlationId);
            this.rm.Pages = this.rm.Pages.filter(a => a.Id !== pageId);
        }
    }

    onCommandFailed(status: any)
    {
        if (CreateRequestPageCommandV1.matchType(status.Command))
        {
            for (const error of status.ValidationErrors)
            {
                alert(error.Error);
            }
        }
        else if (CloneRequestPageCommandV1.matchType(status.Command))
        {
            for (const error of status.ValidationErrors)
            {
                alert(error.Error);
            }
        }
    }
}